<template>
  <div>
    <div class="card spinner" v-if="store.loader > 0">
      <ProgressSpinner />
    </div>
    <section id="container">
      <HeaderSideBar
        :is_not_expand="is_not_expand"
        :update-available="updateAvailable"
        @call="onPinToggle"
        @menu-collapse="onMenuCollapse"
        @reload-to-update="reloadToUpdate"
        v-if="show_sidebar"
      />
      <div :class="[getClassName(), { 'no-margin': isPreviewShownPopup }]">
        <router-view @toggle-preview="handleTogglePreview" />
      </div>
      <!-- <ToastMessage /> -->
      <section
        id="main-content"
        v-if="
          $route.name !== 'Login' &&
          $route.name !== 'Blank' &&
          $route.name !== 'ForgotPassword' &&
          $route.name !== 'ResetPassword' &&
          $route.name !== 'ChangePassword' &&
          $route.name !== 'ManageDealUpdateById' &&
          $route.name !== 'ManageDealUpdateCreate' &&
          $route.name !== 'copydeal' &&
          showFooter
        "
      >
        <!-- <footer class="site-footer">
          <div class="text-center">
            {{ new Date().getFullYear() }} &copy; Voyado AB
          </div>
        </footer> -->
      </section>
      <section
        id="footer-change"
        v-if="
          ($route.name == 'ManageDealUpdateById' ||
            $route.name == 'ManageDealUpdateCreate') &&
          showFooter
        "
      >
        <!-- <footer class="site-footer">
          <div class="text-center">
            {{ new Date().getFullYear() }} &copy; Voyado AB
          </div>
        </footer> -->
      </section>
    </section>
    <ToastMessage :key="Date.now()" />
    <!-- <PrimeToast /> -->
    <VersionUpdateBadge
      :visible="updateAvailable && !isHeaderVisible"
      @reload="reloadToUpdate"
    />
  </div>
</template>

<script>
import HeaderSideBar from "@/components/layout/HeaderSidebarNew.vue";
import VersionUpdateBadge from "@/components/modal-popup/version-update-badge.vue";
import DataLayerService from "@/services/data-layer.service";
import { useMainStore } from "@/store/main";
import {
  APP_VERSION_STORAGE_KEY,
  fetchDeployedVersion,
  getCurrentVersion,
  isStoredVersionDifferent,
  saveVersion,
} from "@/utils/app-version";

// Guards against bursts of fetches from redirects / focus + visibility firing together
const VERSION_MIN_FETCH_GAP_MS = 10 * 1000;
// Catches new deploys while the user stays idle on one page
const VERSION_IDLE_CHECK_MS = 5 * 60 * 1000;
const VERSION_CHECK_SKIP_ROUTES = [
  "Login",
  "Logout",
  "ForgotPassword",
  "ResetPassword",
  "ChangePassword",
  "Blank",
  "notfound",
  "CatchAll",
];
// Must match the header's v-if in HeaderSidebarNew.vue
const HEADERLESS_ROUTES = ["Blank", "ManageDealUpdateCreate", "ManageDealUpdateById", "copydeal"];

export default {
  components: {
    HeaderSideBar,
    VersionUpdateBadge,
  },
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      renderKey: 0,
      is_not_expand: false,
      isPinned: false,
      isPreviewShownPopup: false,
      showParam: null,
      changeRef: false,
      show_sidebar: true,
      showFooter: false,
      messageListener: null,
      // When the menu is pinned, a menu item without an expanded submenu
      // collapses the panel; track that so the content margin follows the
      // panel's actual visibility instead of just the pin toggle.
      menuCollapsedWhilePinned: false,
      updateAvailable: false,
      currentVersion: getCurrentVersion(),
      lastDeployedCheckAt: 0,
      deployedCheckInFlight: false,
      versionIdleTimer: null,
    };
  },
  computed: {
    isHeaderVisible() {
      return this.show_sidebar && !HEADERLESS_ROUTES.includes(this.$route.name);
    },
  },
  watch: {
    "store.loader": {
      handler(newValue) {
        document.querySelector("body").style.overflow =
          newValue > 0 ? "hidden" : "auto";
      },
      immediate: true,
    },
    $route() {
      this.changeRef = false;
      this.updateUrlParamsFromRoute(); // Update store with current route params
      this.checkVersion();
    },
  },
  created() {
    // A freshly loaded page already runs this build, however it was loaded (new tab, F5, auto-refresh)
    saveVersion(this.currentVersion);
  },
  mounted() {
    window.addEventListener("error", (e) => {
      if (e.message.includes("404")) {
        this.$router.push({ name: "Login" });
      }
    });
    this.setupAuth0Listener();
    this.updateUrlParamsFromRoute(); // Initial update on mount
    this.checkVersion();
    document.addEventListener("visibilitychange", this.onVisibilityChange);
    window.addEventListener("focus", this.checkVersion);
    window.addEventListener("storage", this.onStorageChange);
    this.versionIdleTimer = setInterval(this.checkVersion, VERSION_IDLE_CHECK_MS);
  },
  beforeUnmount() {
    document.removeEventListener("visibilitychange", this.onVisibilityChange);
    window.removeEventListener("focus", this.checkVersion);
    window.removeEventListener("storage", this.onStorageChange);
    clearInterval(this.versionIdleTimer);
    if (this.messageListener) {
      window.removeEventListener("message", this.messageListener);
    }
  },
  updated() {
    if (
      this.$route.name !== undefined &&
      this.$route.name !== null &&
      this.$route.name !== "" &&
      this.changeRef == false
    ) {
      const queryParams = new URLSearchParams(window.location.search);
      const showParam = queryParams.get("show");
      const hideMenu = queryParams.get("hide");
      const newQuery = {};

      queryParams.forEach((value, key) => {
        newQuery[key] = value;
      });

      this.show_sidebar = true;
      this.is_not_expand = this.isPinned && !this.menuCollapsedWhilePinned;
      this.showFooter = true;

      const routesWithoutSidebar = [
        "Login",
        "Blank",
        "ForgotPassword",
        "ResetPassword",
        "ChangePassword",
        "copydeal",
        "essence",
      ];
      if (routesWithoutSidebar.includes(this.$route.name)) {
        this.show_sidebar = false;
        this.is_not_expand = false;
        this.showFooter = false;
      }

      if (showParam === "deallistnew") {
        this.$router.push({ name: "ManageDealList", query: newQuery });
        this.is_not_expand = true;
        this.show_sidebar = false;
        this.expand();
      } else if (showParam === "deallist" || showParam === "deallis") {
        if (this.$route.name !== "ManageDealListNew") {
          this.$router.push({ name: "ManageDealListNew", query: newQuery });
        }
        this.is_not_expand = true;
        this.show_sidebar = false;
        this.expand();
      }

      if (hideMenu === "menu") {
        this.show_sidebar = false;
        this.is_not_expand = false;
        this.expand();
      }

      if (
        this.$route.name === "ManageDealUpdateById" ||
        this.$route.name === "ManageDealUpdateCreate"
      ) {
        this.showFooter = true;
      }

      this.changeRef = true;
    }
  },
  methods: {
    canCheckVersion() {
      if (this.updateAvailable) return false;
      if (!this.$route.name || VERSION_CHECK_SKIP_ROUTES.includes(this.$route.name)) return false;
      const cognitoInfo = this.store.cognitoInfo;
      return !!cognitoInfo && Object.keys(cognitoInfo).length > 0;
    },
    checkVersion() {
      if (!this.canCheckVersion()) return;
      if (isStoredVersionDifferent(this.currentVersion)) {
        this.updateAvailable = true;
      } else {
        this.checkDeployedVersion();
      }
    },
    async checkDeployedVersion() {
      if (!this.currentVersion || this.deployedCheckInFlight) return;
      if (document.visibilityState === "hidden") return;
      if (Date.now() - this.lastDeployedCheckAt < VERSION_MIN_FETCH_GAP_MS) return;
      this.lastDeployedCheckAt = Date.now();
      this.deployedCheckInFlight = true;
      try {
        const deployed = await fetchDeployedVersion();
        if (deployed && deployed !== this.currentVersion) {
          this.updateAvailable = true;
        }
      } finally {
        this.deployedCheckInFlight = false;
      }
    },
    onVisibilityChange() {
      if (document.visibilityState === "visible") this.checkVersion();
    },
    onStorageChange(event) {
      // Another tab loaded a different version
      if (event.key === APP_VERSION_STORAGE_KEY) this.checkVersion();
    },
    reloadToUpdate() {
      window.location.reload();
    },
    inIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
    expand() {
      this.is_not_expand = !this.is_not_expand;
    },
    onPinToggle(isPinned) {
      this.isPinned = isPinned;
      this.menuCollapsedWhilePinned = false;
      this.is_not_expand = isPinned;
    },
    onMenuCollapse(collapsed) {
      // Emitted by the sidebar when a pinned menu item has no expanded panel.
      this.menuCollapsedWhilePinned = collapsed;
      this.is_not_expand = this.isPinned && !collapsed;
    },
    handleTogglePreview() {
      if (this.isPreviewShownPopup == true) {
        this.isPreviewShownPopup = false;
        this.show_sidebar = true;
      } else {
        this.isPreviewShownPopup = true;
        this.show_sidebar = false;
      }
    },
    getClassName() {
      if (this.inIframe()) {
        this.show_sidebar = false;
        this.is_not_expand = false;
        return "in-iframe";
      } else if (this.is_not_expand) {
        return "not-expand";
      } else if (
        this.$route.name !== "Login" &&
        this.$route.name !== "ForgotPassword" &&
        this.$route.name !== "ResetPassword" &&
        this.$route.name !== "ChangePassword" &&
        this.$route.name !== "copydeal" &&
        this.$route.name !== "essence" &&
        this.$route.name !== "Blank"
      ) {
        return "expand";
      }
      return "";
    },
    setupAuth0Listener() {
      console.log("Setting up logout listener");

      const onMsg = (e) => {
        console.log(
          "App: Received message",
          e,
          "and",
          e.data,
          "and",
          this.store.origin
        );

        if (
          e.data &&
          typeof e.data === "object" 
          // &&
          // e.origin === this.$store.state.origin
        ) {
          console.log(
            "App: Valid message from trusted origin",
            e.origin,
            e.data,
            // this.store.origin
          );

          const { type } = e.data;
          if (type === "LOGOUT") {
            console.log("App: Logging out");
            // const targetOrigin = this.store.origin || "*"; // Fallback to "*" if origin is empty
            const accessToken = this.store.accesstoken;
            const refreshToken = this.store.refreshtoken;
            const email = this.store.cognitoInfo.email;

            if (accessToken && refreshToken && email) {
              try {
                const payload = { accessToken, refreshToken, email };
                DataLayerService.post("/auth/Logout", payload);
              } catch (error) {
                console.error("Logout API call failed:", error);
              }
            }
            this.store.resetOnLogout();
            window.parent.postMessage({ type: "LOGOUT_ACK" }, e.origin);
            
            console.log(
              "Sending LOGOUT_ACK to parent window, origin:",
              e.origin
            );

            // Navigate to Blank page after timeout
            setTimeout(() => {
              console.log("Navigating to Blank page after timeout");
              this.$router.push({ name: "Blank" });
            }, 2000); // 2000ms = 2 second delay
          }
          // else if (type === "LOGOUT_ACK") {
          //   console.log("App: Child acknowledged logout");
          //   this.$store.commit("resetOnLogout");
          //   this.$router.push({ name: "Login" });
          // }
        }
      };

      this.messageListener = onMsg;
      window.addEventListener("message", this.messageListener);
    },
    updateUrlParamsFromRoute() {
      const queryParams = new URLSearchParams(window.location.search);
      const params = {
        tenant: queryParams.get("tenant"),
        origin: queryParams.get("origin"),
        email: queryParams.get("email"),
        language: queryParams.get("language"),
        expectedIssuer: queryParams.get("expectedIssuer"),
        expectedAudience: queryParams.get("expectedAudience"),
        organization: queryParams.get("organization"),
        connection: queryParams.get("connection"),
      };

      // Commit only if params differ from current store state to avoid unnecessary updates
      if (params.origin !== this.store.origin) {
        this.store.setOrigin(params.origin);
      }
      if (params.tenant !== this.store.tenant) {
        this.store.setTenant(params.tenant);
      }
      if (params.language !== this.store.language) {
        this.store.setLanguage(params.language);
      }
      if (params.expectedIssuer !== this.store.expectedIssuer) {
        this.store.setExpectedIssuer(params.expectedIssuer);
      }
      if (params.expectedAudience !== this.store.expectedAudience) {
        this.store.setExpectedAudience(params.expectedAudience);
      }
      if (params.organization !== this.store.organization) {
        this.store.setOrganization(params.organization);
      }
      if (params.connection !== this.store.connection) {
        this.store.setConnection(params.connection);
      }

      // Check for email mismatch and redirect to Login if different
      const storedEmail = this.store.emailParam;
      const paramEmail = params.email;
      if (paramEmail && storedEmail && paramEmail !== storedEmail) {
        console.log("Email mismatch detected - Stored:", storedEmail, "Param:", paramEmail);
        this.$router.push({ name: "Login" });
      }

      console.log("Updated store params from route:", params);
    },
  },
};
</script>

<style scoped>
.no-margin {
  margin-left: 0 !important;
}
.expand {
  margin-left: 90px;
  transition-timing-function: ease-in-out;
  transition-duration: 0.3s;
}
.not-expand {
  margin-left: 340px;
  transition-timing-function: ease-in-out;
  transition-duration: 0.3s;
}
.pinMenu {
  margin-left: 330px;
  transition-timing-function: ease-in-out;
  transition-duration: 0.3s;
}
.min-expand {
  margin-left: 0px;
  transition-timing-function: ease-in-out;
  transition-duration: 0.3s;
}
.in-iframe {
  margin-left: 0px;
  transition-timing-function: ease-in-out;
  transition-duration: 0.3s;
}
#container {
  min-height: 100%;
}
</style>